<!-- コメント用 文字数カウンター付きテキストエリアコンポーネント -->
<template>
  <Field
    v-if="name"
    :name="name"
    :model-value="modelValue ?? ''"
    :rules="rules"
    :validate-on-input="validateOnInput"
    v-slot="{ field, errors }"
  >
    <div class="config-memo">
      <textarea
        :id="id"
        :name="field.name"
        :data-testid="field.name"
        :class="['memo', inputClass, { 'is-error': errors && errors.length > 0 }]"
        :rows="rows"
        :maxlength="limit"
        :value="field.value ?? ''"
        @input="onFieldInput($event, field)"
        @blur="onFieldBlur($event, field)"
      />
      <span class="count">
        残<span class="unit-en">{{ remainingFrom(field.value ?? '') }}</span
        >文字
      </span>
    </div>
  </Field>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate'
import { computed } from 'vue'

const props = defineProps<{
  modelValue?: string
  name?: string
  rules?: string | Record<string, unknown>
  id?: string
  rows?: number
  limit?: number
  inputClass?: string | string[] | Record<string, boolean>
  validateOnInput?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'blur'): void
}>()

const limit = computed(() => props.limit ?? 100)
const validateOnInput = props.validateOnInput ?? true

// Field 経由用
function remainingFrom(value: string) {
  return Math.max(limit.value - (value?.length ?? 0), 0)
}

function onFieldInput(event: Event, field: any) {
  const v = (event.target as HTMLTextAreaElement).value.slice(0, limit.value)
  if (field.onChange) {
    field.onChange(v)
  } else if (field.onInput) {
    field.onInput(event)
  }
  emit('update:modelValue', v)
}

function onFieldBlur(event: FocusEvent, field: any) {
  field.onBlur?.(event)
  emit('blur')
}
</script>
